/**
 * The error trace's read side (19/10/2026): a country's errors over the
 * last N run days with the tallies and the Slack state — a light 30 s poll
 * while on screen — and the index page's per-country summary. `at` = the
 * DEV simulated clock, null = now.
 * For Media Devoted | Created By Ciro Autiero
 */
import { useQuery } from '@tanstack/react-query';
import type { DropGenErrorsReport, DropGenErrorsSummary } from '@trafficpulse/shared';

import { api } from '@/services/api';

import { dropGeneratorKeys } from '../useDropGenerator';

interface Envelope<T> {
  data: T;
}

const BASE = '/drop-generator/errors';

export function useErrorsReport(countryKey: string | null, days: number, at: string | null = null) {
  return useQuery({
    queryKey: [...dropGeneratorKeys.all, 'errors', countryKey ?? 'none', days, at] as const,
    queryFn: async () => {
      const res = await api.get<Envelope<DropGenErrorsReport>>(`${BASE}/${countryKey}`, { params: { days, ...(at ? { at } : {}) } });
      return res.data.data;
    },
    enabled: Boolean(countryKey),
    refetchInterval: 30_000,
    staleTime: 10_000,
    retry: false,
  });
}

export function useErrorsSummary(at: string | null = null, enabled = true) {
  return useQuery({
    queryKey: [...dropGeneratorKeys.all, 'errors-summary', at] as const,
    queryFn: async () => {
      const res = await api.get<Envelope<DropGenErrorsSummary>>(`${BASE}/summary`, { params: at ? { at } : {} });
      return res.data.data;
    },
    enabled,
    refetchInterval: 30_000,
    staleTime: 10_000,
    retry: false,
  });
}
